import FilesCard from '@components/cards/files/Files.card';
import SelectFileComponent from '@components/inputs/selectFile/SelectFile.component';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { CreateAuditOperation } from '@store/audits/audits-operation/audits-operation.model';
import { DocumentInfo, DocumentKind, filesService } from '@store/files';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

interface AuditContainerProps {
  auditOperation?: CreateAuditOperation;
  updateAuditOperation: <T extends keyof CreateAuditOperation>(
    field: T,
    value: CreateAuditOperation[T]
  ) => void;
}

const PictureInformation = (props: AuditContainerProps) => {

  const {
    auditOperation,
    updateAuditOperation
  } = props;

  const { t } = useTranslation();
  const {enqueueSnackbar} = useSnackbar();

  const removeDocumentFromAddedDocuments = (document: DocumentInfo) => {
    const docs = auditOperation?.addedDocuments?.filter((doc) => doc.id !== document.id);
    updateAuditOperation('addedDocuments', docs);
  };

  const removeDocuments = (document: number) => {
    const docs = auditOperation?.deletedDocuments ?? [];
    docs.push(document);
    updateAuditOperation('deletedDocuments', docs);
  };
  const addDocument = (file: File) => {
    filesService.uploadFile(file, DocumentKind.ISSUE).pipe().subscribe({
      next: (document) => {
        const docs = auditOperation?.addedDocuments ?? [];
        docs.push(document);
        updateAuditOperation('addedDocuments', docs);
      },
      error: (err) => enqueueSnackbar(err.text, err.options),
    });
  };

  return (
    <Stack py="24px" pr="10px" spacing={1.5}>
      <Stack direction="row" alignItems="center" justifyContent="space-between">
        <Typography fontSize="18px" fontWeight="700">
          {t('audits.preAudit.observations.pictures')}
        </Typography>
        <SelectFileComponent handleFileSelected={addDocument} />
      </Stack>
      <Box>
        {auditOperation?.addedDocuments?.length !== 0 && auditOperation?.addedDocuments?.map((photo, index) => {
          return (
              <FilesCard key={index} document={photo} handleDeleteDocument={() => removeDocumentFromAddedDocuments(photo)}/>
          );
        })}
        {auditOperation?.documents?.length !== 0 && auditOperation?.documents?.map((photo, index) => (
            !auditOperation?.deletedDocuments?.includes(photo.id) && (
                photo.name && (
                    <FilesCard key={index} document={photo} handleDeleteDocument={() => removeDocuments(photo.id)}/>
                )
            )
        ))}

      </Box>
      <Divider variant="fullWidth" orientation="horizontal" />
    </Stack>
  );
};

export default PictureInformation;